import { useApi } from '@composables/useApi';
import { defineStore } from 'pinia';
import { FailedGetTrafficStatsError, TrafficStats } from '@store/api/interfaces';
import { useAuthApi } from '@store/api/authApi';

/**
 * Основной трафик для строки под кнопкой на главной: сколько потрачено с последней
 * оплаты и за всё время. Считает и кэширует бэкенд кабинета по данным панели —
 * фронт ничего не суммирует сам.
 */
export const useTrafficApi = defineStore('trafficApi', () => {
	const authApi = useAuthApi();

	const http = {
		// Требует авторизации. `null` в полях — данных нет, а не ноль.
		getStats: async (): Promise<TrafficStats> => {
			try {
				return await useApi<TrafficStats>('/traffic', {
					method: "GET",
					headers: authApi.methods.getAuthHeaders()
				});
			} catch (error: any) {
				console.error('failed get traffic stats', error);
				throw new FailedGetTrafficStatsError(error.message);
			}
		}
	};

	const methods = {};

	return {
		http,
		methods
	};
});
